import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

// Import page components
import Home from './components/Home';
import About from './components/About';
import PrivacyPolicy from './components/PrivacyPolicy';
import CookiesPolicy from './components/CookiesPolicy';
import CookieConsent from './components/CookieConsent';

// Import cookie utilities
import { initializeScripts } from './utils/scriptLoader';

// Custom hook for scroll to top and page titles
function ScrollToTop() {
  const { pathname } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    // Only scroll to top if the pathname actually changed
    if (prevPathname.current !== pathname) {
      window.scrollTo(0, 0);
      prevPathname.current = pathname;
    }
    
    // Update page title for SEO
    switch (pathname) {
      case '/':
        document.title = 'dpTech - Data Solutions';
        break;
      case '/about':
        document.title = 'dpTech - Chi Siamo';
        break;
      case '/privacy':
        document.title = 'dpTech - Privacy Policy';
        break;
      case '/cookies':
        document.title = 'dpTech - Cookies Policy';
        break;
      default:
        document.title = 'dpTech';
    }
  }, [pathname]);

  return null;
}

function App() {
  const [isLoading, setIsLoading] = useState(false);
  const [currentPath, setCurrentPath] = useState('/');

  // Initialize scripts based on cookie consent
  useEffect(() => {
    initializeScripts();
  }, []);

  const handleRouteChange = (newPath) => {
    if (newPath !== currentPath) {
      setIsLoading(true);
      setCurrentPath(newPath);
      
      // Simulate loading time for better UX
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    }
  };

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        {/* Loading Overlay */}
        {isLoading && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            transition: 'opacity 0.3s ease'
          }}>
            <div style={{
              background: '#fff',
              padding: '30px 50px',
              borderRadius: '15px',
              textAlign: 'center',
              boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
            }}>
              <div style={{
                width: '40px',
                height: '40px',
                border: '4px solid #f3f3f3',
                borderTop: '4px solid #FFD84D',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                margin: '0 auto 15px'
              }}></div>
              <p style={{margin: 0, color: '#333', fontSize: '16px', fontWeight: '500'}}>Caricamento...</p>
            </div>
          </div>
        )}

        <Routes>
          <Route path="/" element={<Home onRouteChange={() => handleRouteChange('/')} />} />
          <Route path="/about" element={<About onRouteChange={() => handleRouteChange('/about')} />} />
          <Route path="/privacy" element={<PrivacyPolicy onRouteChange={() => handleRouteChange('/privacy')} />} />
          <Route path="/cookies" element={<CookiesPolicy onRouteChange={() => handleRouteChange('/cookies')} />} />

        </Routes>
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;
